module.exports = __webpack_public_path__ + "static/media/avatar.36f92bd4.png";